import { render } from "./FormAddUsersAuction.vue?vue&type=template&id=1ce47148"
import script from "./FormAddUsersAuction.vue?vue&type=script&lang=js"
export * from "./FormAddUsersAuction.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__